import { IconButton } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";
import { SIBreadcrumbs } from "app/pages/sales-intelligence/common-components/SIBreadcrumbs/SIBreadcrumbs";
import { SignalsManagementSection } from "app/pages/sales-intelligence/common-components/SignalsManagementSection/SignalsManagementSection";
import { MANAGEMENT_APIS_AND_WEBHOOKS_ROUTE } from "app/pages/sales-intelligence/constants/sl_routes";
import GetApiKeyButton from "app/pages/sales-intelligence/modules/manage-integrations/components/GetApiKeyButton/GetApiKeyButton";
import manageIntegrationsTrackingService from "app/pages/sales-intelligence/modules/manage-integrations/services/tracking";
import { SIGNALS_REST_API_DOCS_URL } from "app/pages/sales-intelligence/modules/management/sub-modules/constants";
import { SignalsApiListTypesContainer } from "app/pages/sales-intelligence/modules/management/sub-modules/signals-api/containers/SignalsApiListTypesContainer/SignalsApiListTypesContainer";
import { SignalsRestApiEmptyView } from "app/pages/sales-intelligence/modules/signals-rest-api/components/SignalsRestApiEmptyView/SignalsRestApiEmptyView";
import { SIGNALS_REST_API_BREADCRUMBS } from "app/pages/sales-intelligence/pages/management/constants/breadcrumbs";
import siNavigator from "app/pages/sales-intelligence/services/siNavigator";
import SignalsManagementButtonContainer from "app/pages/sales-intelligence/sub-modules/signals/containers/SignalsManagementButton";
import withSignalsManagement from "app/pages/sales-intelligence/sub-modules/signals/hoc/withSignalsManagement";
import { usePermanentSignalsAmountBySource } from "app/pages/sales-intelligence/sub-modules/signals/hooks/useUISignals";
import SignalSource from "app/pages/sales-intelligence/sub-modules/signals/models/core/SignalSource";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import {
    StyledBreadcrumbsContainer,
    StyledHeader,
    StyledManagementHeader,
    StyledManagementTabsContainer,
    StyledManagementTitle,
    StyledManagementWrapper,
} from "../SignalsManagementIntegrationContainer/styles";

const SignalsRestApiManagementContainer = () => {
    const signalsAmount = usePermanentSignalsAmountBySource();

    const handleOnManagementClick: VoidFunction = () => {
        manageIntegrationsTrackingService.trackApiCardClick("signalsRestApi");
    };

    const handleEmptyViewClick: VoidFunction = () => {
        manageIntegrationsTrackingService.trackApiCardClick("signalsRestApi");
    };

    const handleBreadcrumbClick = ({ state: breadcrumbState }: { state: string }): void => {
        if (breadcrumbState === MANAGEMENT_APIS_AND_WEBHOOKS_ROUTE) {
            void siNavigator.goToAPIsWebhooksPage();
            return;
        }

        void proNavigator.go(breadcrumbState);
    };

    const breadcrumbs = SIGNALS_REST_API_BREADCRUMBS.map((item) => ({ ...item, title: translate(item.title) }));

    const handleGuideClick = (): void => {
        manageIntegrationsTrackingService.trackApiGuideClick("signalsRestApi");
    };

    return (
        <StyledManagementWrapper data-automation="signals-rest-api-management-page">
            <StyledBreadcrumbsContainer>
                <SIBreadcrumbs
                    variant="spaceBetween"
                    list={breadcrumbs}
                    onClick={handleBreadcrumbClick}
                    dataAutomation="signals-rest-api-manage-breadcrumbs"
                >
                    <a
                        href={SIGNALS_REST_API_DOCS_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <IconButton
                            iconName="helpcenter"
                            type="flat"
                            data-automation="signals-rest-api-management.guide-button"
                            onClick={handleGuideClick}
                        />
                    </a>
                </SIBreadcrumbs>
            </StyledBreadcrumbsContainer>

            <StyledManagementTabsContainer>
                <StyledHeader>
                    <StyledManagementHeader>
                        <I18n
                            element={StyledManagementTitle}
                            translatable={{ key: "si.management.integration.signals-rest-api.page.title" }}
                        />
                        <GetApiKeyButton
                            apiType="signalsRestApi"
                            dataAutomation="signals-rest-api-management.get-api-key-button"
                        />
                    </StyledManagementHeader>
                </StyledHeader>

                <SignalsManagementSection
                    title={translate("si.management.integration.signals-rest-api.section.set-signals")}
                    subTitle={translate("si.management.integration.signals-rest-api.section.set-signals.subtitle")}
                    actionButton={
                        signalsAmount > 0 ? (
                            <SignalsManagementButtonContainer
                                fillButtonText="si.management.integration.signals-rest-api.section.set-signals.manage-signals"
                                onClick={handleOnManagementClick}
                            />
                        ) : null
                    }
                >
                    {signalsAmount > 0 ? (
                        <SignalsApiListTypesContainer />
                    ) : (
                        <SignalsRestApiEmptyView onClick={handleEmptyViewClick} />
                    )}
                </SignalsManagementSection>
            </StyledManagementTabsContainer>
        </StyledManagementWrapper>
    );
};

export default withSignalsManagement(SignalsRestApiManagementContainer, SignalSource.RestApi);
